import { render, staticRenderFns } from "./AdministrationModuleRoot.vue?vue&type=template&id=553f6e51&scoped=true&lang=html&"
import script from "./AdministrationModuleRoot.vue?vue&type=script&lang=js&"
export * from "./AdministrationModuleRoot.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationModuleRoot.vue?vue&type=style&index=0&id=553f6e51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553f6e51",
  null
  
)

export default component.exports